export const LostAndFoundSkeleton = () => {
  return (
    <div className="flex w-[80%] items-center justify-center self-center">
      <div className="flex w-full max-w-4xl lg:max-w-5xl flex-col items-center gap-y-6 px-4">
        <div className="h-8 w-48 animate-pulse rounded bg-gray-300" />
        <div className="grid w-full grid-cols-1 justify-items-center gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-64 w-full max-w-sm animate-pulse rounded bg-gray-200 sm:max-w-md lg:max-w-lg"
            />
          ))}
        </div>
      </div>
    </div>
  );
};
